"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartContinueShoppingWithEmptyCart = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartContinueShoppingWithEmptyCart(clickElementText, clickText, clickUrl) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: enums_1.EventLabelCartButtonClickEnum.ContinueShopping,
        eventData: {
            feature_category: enums_1.GA4FeatureCategory.Cart,
            eventName: enums_1.GA4EventName.ClickButton,
            click_element: clickElementText,
            click_text: clickText,
            click_url: clickUrl,
        },
    });
}
exports.trackCartContinueShoppingWithEmptyCart = trackCartContinueShoppingWithEmptyCart;
//# sourceMappingURL=trackCartContinueShoppingWithEmptyCart.js.map